const queryString = require('query-string');

export var parsed = () => {
	let search = window.location.hash
	search = search.replace(/^[^?]*/, '');
	var parsed = queryString.parse(search);
	return parsed
}